'use client';

import ScrollFade from '@/components/ui/ScrollFade/ScrollFade';
import { montserrat } from '@/lib/font';
import { getLocalizedText, isEnglish, isJapanese } from '@/lib/l18n/function';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { useTranslation } from 'react-i18next';
import type { LotteryBenefit, LotteryCustomOption, LotteryDrawHistoryLineup } from '../../types';
import LotteryGoodsList from '../LotteryGoodsList/LotteryGoodsList';
import styles from './LotteryBenefitList.module.scss';

function LotteryBenefitList({
  lotteryStatus,
  benefitList,
  lotteryDrawHistory,
  customOptions,
}: {
  lotteryStatus: string;
  benefitList: Array<LotteryBenefit>;
  lotteryDrawHistory?: Array<LotteryDrawHistoryLineup>;
  customOptions?: LotteryCustomOption;
}) {
  const { i18n } = useTranslation();
  return (
    <>
      <ul className={styles.componentStyle}>
        {benefitList.map((benefit) => (
          <ScrollFade tag={'li'} key={`benefit_${benefit.id}`}>
            <div className={styles.itemCard}>
              {/* 特典 */}
              {benefit.benefitMultiDrawCount > 0 && (
                <div className={styles.benefitWrapper}>
                  {isJapanese(i18n.resolvedLanguage) ? (
                    <>
                      <span className={montserrat.className}>{benefit.benefitMultiDrawCount}</span>
                      <small>連特典</small>
                    </>
                  ) : (
                    isEnglish(i18n.resolvedLanguage) && (
                      <>
                        <small>Bonus for&nbsp;</small>
                        <span className={montserrat.className}>{benefit.benefitMultiDrawCount}</span>
                        <small>&nbsp;draws</small>
                      </>
                    )
                  )}
                </div>
              )}
              {/* 景品ラベル名 */}
              <div className={`${styles.itemName} ${utilsStyles.textLarge} ${utilsStyles.textBold}`}>
                {getLocalizedText(i18n.resolvedLanguage, { ja: benefit.name, en: benefit.categoryName_en })}
              </div>
              {/* 景品ラベル詳細 */}
              <div className={`${styles.itemDescription} ${utilsStyles.textSmall}`}>
                {getLocalizedText(i18n.resolvedLanguage, { ja: benefit.description, en: benefit.description_en })}
              </div>
              {/* 景品一覧 */}
              <LotteryGoodsList
                lotteryStatus={lotteryStatus}
                goodsList={benefit.goods}
                linupId={benefit.id}
                lotteryDrawHistory={lotteryDrawHistory}
                liKeyPrefix={'benefit_goods'}
                customOptions={customOptions}
              />
            </div>
          </ScrollFade>
        ))}
      </ul>
    </>
  );
}

export default LotteryBenefitList;
